import type { GuideStep } from './BankRegistrationGuide';
import { GATEWAY_NUMBER_DISPLAY } from './wooriGuide';

export const SHINHAN_REQUEST_CODE_STEPS: GuideStep[] = [
  { title: '신한 SOL뱅크 → 전체메뉴 → 설정/인증' },
  { title: '알림 → 아래로 스크롤 → 입출금 문자(유료)' },
  { title: '신청할 계좌 선택 후 "통지휴대폰 추가"' },
  {
    title: '“추가등록할 통지휴대폰 정보”에 아래 셀러헬퍼 번호 입력',
    detail: `내 휴대폰 번호가 아니라 ${GATEWAY_NUMBER_DISPLAY}를 입력해주세요.`,
    detailTone: 'danger',
  },
  { title: '[인증요청]을 누르기' },
];

export const SHINHAN_COMPLETE_REGISTRATION_STEPS: GuideStep[] = [
  { title: '위에 표시된 6자리 인증번호를 신한 SOL뱅크에 입력' },
  { title: '통지 옵션을 설정하고 [신청]을 눌러 등록 완료' },
];

export const SHINHAN_NOTIFY_OPTIONS: GuideStep[] = [
  { title: '통지항목선택: "입금거래" 또는 "모든거래"' },
  {
    title: '심야시간통지여부: "통지함" 또는 "통지함(C/C제외)"',
    titleTone: 'danger',
  },
  { title: '문자유형: "기본형"' },
  { title: '잔액표시여부: "표시안함" 또는 "표시함"' },
  {
    title: '계좌번호표시여부: "표시함"',
    titleTone: 'danger',
    detail: '계좌번호가 표시되지 않으면 입금 계좌를 구분할 수 없어요.',
    detailTone: 'danger',
  },
];
